export default {
  "navbar": {
    "logo": {
      "link": "#"
    },
    "list": [
      {
        "name": "5G+X 联创营",
        "link": "/#introduce",
        "是否显示": true
      },
      {
        "name": "热点资讯",
        "link": "/#message",
        "是否显示": true
      },
      {
        "name": "大咖观点",
        "link": "/#viewpoint",
        "是否显示": true
      },
      {
        "name": "精彩活动",
        "link": "/#activity",
        "是否显示": true
      },
      {
        "name": "权益和使命",
        "link": "/#scene",
        "是否显示": true
      },
      {
        "name": "加入联创营",
        "link": "/#join",
        "是否显示": true
      }
    ]
  },
  "introduce": {
    "title": {
      "mainTitle": "5G+X 联创营",
      "subTitle": "以5G+云+X为支点，联合伙伴进行创新，撬动未来世界"
    },
    "text": "<span class='color'>华为云5G+X联创营</span>，是由华为云发起，以云、AI、5G为技术底座，与互联网技术创新型企业进行新创新场景联合打造和创新应用联合开发，通过技术生态支持与企业品牌联动，实现双方共赢，推动5G的商用落地，丰富5G生态。",
    "button": {
      "link": "https://e-campaign.huawei.com/cn/5g+x/index.html",
      "text": "查看更多"
    }
  },
  "message": {
    "title": {
      "mainTitle": "热点资讯",
      "subTitle": "最新联创营活动、精彩发布、联创进展都在这里"
    },
    "list": [
      {
        "link": "https://www.infoq.cn/article/5MWT8MCpq8Yljg4eoQNw",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/ab/b2/ab75ae28839ab3572fcd35e91816e0b2.png",
        "title": "趋势即机遇，聚焦新基建风口下的“云 +5G",
        "text": "新基建风口下，互联网企业如何进行业务升级和创新发展？行业专家之间的思想碰撞或许能够给到你不一样的启发。"
      },
      {
        "link": "https://www.infoq.cn/article/cL2MlzvwZHOESPiOkH0P",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/f6/43/f6ccb1fc764b1376591387508868e243.png",
        "title": "详解华为云 5G+X 联创营，联合创新能为互联网企业带来哪些改变？",
        "text": "从云到5G+AI+ 云，技术在融合创新中不断优化升级，赋能企业实现多元化创新增收、降本提效，这也是5G+X联创营的创立意义。"
      },
      {
        "link": "https://www.infoq.cn/article/vL8Dwu68TuRsoHVPH9i8",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/f7/04/f75500c20ab6360764497453ad39b004.png",
        "title": "企业怎么入局 5G 新基建？7 位大咖聊聊变中求胜之道",
        "text": "互联网企业+5G如何实现创新增长？5G、AI、云之间会有怎样的化学反应？联创营与新基建有什么关系？一文详解，干货满满！"
      },
      {
        "link": "https://www.infoq.cn/article/Jj4oxRRB4tIcBjH2iTZi",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/27/61/273f658b8b9bcfa72ca96465fb444761.png",
        "title": "追逐业务变量，创新的路子如何越走越宽？",
        "text": "海量数据下算力提升困难、网络时延等问题成为影响互联网行业发展的关键问题，infoQ采访到华为云两位专家寻找答案。"
      }
    ],
    "button": {
      "link": "javascript:void(0);",
      "text": "查看更多"
    }
  },
  "viewpoint": {
    "title": {
      "mainTitle": "大咖观点",
      "subTitle": "大咖精彩观点集锦，为行业创新与企业发展带来更多新的思路"
    },
    "list": [
      {
        "imgSrc": "https://static001-test.geekbang.org/resource/image/3e/17/3e0ed69af12c243de5d447bc1b750417.png",
        "videoSrc": "https://www.infoq.cn/video/FoxDE0SsYfthsdsJNo4d",
        "name": "聂颂",
        "position": "华为云5G+X解决方案/互联网解决方案 CTO",
        "text": "针对游戏出海，华为云提供了哪些解决方案，如何与游戏公司做到联合创新？"
      },
      {
        "imgSrc": "https://static001-test.geekbang.org/resource/image/11/d1/11ea74e6ad68b489244bcaca0f3253d1.png",
        "videoSrc": "https://www.infoq.cn/video/caKSk8ks2CWxK6tl0LuP",
        "name": "赵其勇",
        "position": "华为无线应用场景实验室（X Labs主任）",
        "text": "5G带来的大带宽能为在线教育“更加突出人的互动”创造条件。关于在教育场景互动体验优化方面，华为云基于5G有怎样的思路？"
      },
      {
        "imgSrc": "https://static001-test.geekbang.org/resource/image/39/b2/3955ba4f23d5369bffabf037bc3805b2.png",
        "videoSrc": "https://www.infoq.cn/video/SagRSiGqeQ51ZBaFhGhr",
        "name": "胡维琦",
        "position": "华为云中国区副总裁",
        "text": "5G+X联创营和新基建之间有什么关联？5G是新基建一个很重要的方向，华为云在新基建的政策下有哪些重要的规划？"
      }
    ]
  },
  "activity": {
    "title": {
      "mainTitle": "精彩活动",
      "subTitle": "多维度活动形式，探索联创真谛，寻找业务快速增长的驱动力"
    },
    "list": [
      {
        "type": "rectangle",
        "marginRight": "20px",
        "link": "https://www.infoq.cn/event/?id=127",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/4d/05/4d4b23891c53878b352d0cbb7bede005.png",
        "title": "TGO十问华为云",
        "text": "通过直播的形式，呈现TGO鲲鹏会与华为云相关负责人的巅峰对话，核心围绕5G+X联创营涉及到的行业前沿问题"
      },
      {
        "type": "rectangle",
        "marginRight": "0",
        "link": "https://www.infoq.cn/event/?id=124",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/4d/05/4d4b23891c53878b352d0cbb7bede005.png",
        "title": "走进华为云",
        "text": "邀请对5G+X联创营感兴趣的企业技术负责人，深入华为内部非公开基地，近距离接触华为尖端技术研究成果，与华为侧专家面对面交流。"
      },
      {
        "type": "square",
        "marginRight": "20px",
        "link": "https://www.infoq.cn/event/?id=126",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/c5/6b/c5fdea2f17e38f401401755dddbe6e6b.png",
        "title": "线上圆桌交流会",
        "text": "邀请多位不同行业内的权威专家，通过线上会议的形式展开闭门讨论，核心围绕互联网行业时下有关技术创新的热点问题。"
      },
      {
        "type": "square",
        "marginRight": "20px",
        "link": "https://www.infoq.cn/event/?id=125",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/c5/6b/c5fdea2f17e38f401401755dddbe6e6b.png",
        "title": "线下闭门讨论会",
        "text": "邀请多位不同行业内的权威专家，线下展开闭门互动讨论，核心围绕各企业在某个具体领域内遇到的问题和解决方案进行思想碰撞。"
      },
      {
        "type": "rectangle",
        "marginRight": "0",
        "link": "https://www.infoq.cn/event/?id=123",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/4d/05/4d4b23891c53878b352d0cbb7bede005.png",
        "title": "年终晚宴",
        "text": "邀请参与过联创计划活动的嘉宾再次相聚，回顾全年的历程与联创成果，并对有特别贡献的嘉宾予以颁奖。"
      }
    ],
    "button": {
      "link": "javascript:void(0);",
      "text": "查看更多"
    }
  },
  "scene": {
    "title": {
      "mainTitle": "联创场景",
      "subTitle": "以联合创新来加速各行各业数字化、智能化转型与升级"
    },
    "list": [
      {
        "link": "https://www.huaweicloud.com/solution/5G/5Ggaming.html",
        "title": "5G游戏",
        "text": "云+AI+5G重塑泛互联网文娱新形态，游戏将加速从端侧向云端汇聚，加速流化。"
      },
      {
        "link": "https://www.huaweicloud.com/solution/5G/5Gmedia.html",
        "title": "智慧融媒体",
        "text": "5G、云计算、大数据、AI等技术，融合VR/AR，超高清视频技术并联合专业合作伙伴构建5G媒体解决方案助力客户建设好运用好新媒体平台。"
      },
      {
        "link": "https://www.huaweicloud.com/solution/5G/5Geducation.html",
        "title": "在线教育",
        "text": "更高效、更有乐趣、追求用户极致体验，同时希望随时随地共享一流教育资源。"
      },
      {
        "link": "https://www.huaweicloud.com/solution/businesscloud/",
        "title": "智慧电商",
        "text": "5G、云计算、大数据、人工智能等底层技术能力并联合专业电商行业合作伙伴打造智慧电商解决方案。"
      },
      {
        "link": "https://www.huaweicloud.com/solution/Onlinevideolive/",
        "title": "5G直播",
        "text": "包括VR直播，VR实景，4K直播。伴随着5G、VR/AR等新技术的成熟，人们的体验感、获得感会进一步得到满足，以电商、娱乐、教育为代表的产业也将进行新一轮升级。"
      },
      {
        "link": "https://e-campaign.huawei.com/cn/5g+x/index.html",
        "title": "鲲鹏+昇腾",
        "text": "“新基建”发展离不开算力，而算力与芯片、服务器、存储等硬件设施正相关，而为数字化企业提供算力的一般为混合云。“A鲲鹏 + D昇腾”极简鲲鹏云，打造极致性价比。"
      }
    ]
  },
  "serve": {
    "title": {
      "mainTitle": "华为云5G+X联创营为创新伙伴提供如下服务",
      "subTitle": "华为云将持续赋能企业实现多元化创新增收、降本增效"
    },
    "list": [
      {
        "title": "定期的技术及商业研讨",
        "text": "根据合作伙伴自身的业务场景，结合华为云的业务理解帮助合作伙伴梳理战略、打造联合创新场景，增强合作伙伴的解决方案能力"
      },
      {
        "title": "产品开发指导",
        "text": "由华为云资深架构师与合作伙伴对合作伙伴开发联合创新场景提供指导，探讨并确定最优技术架构"
      },
      {
        "title": "开辟线上联创专区",
        "text": "为互联网伙伴提供优惠券服务，帮助伙伴在华为云创新专区完成5G创新应用及技术的开发、测试、部署等，使得”线上创新“成为可能"
      },
      {
        "title": "创新场景孵化",
        "text": "针对有价值的云、AI、5G的新场景、新应用，华为云结合自身技术优势和商业理解为其创新优化提供所需的技术与赋能支持"
      },
      {
        "title": "品牌联合营销",
        "text": "与伙伴一起联合发布解决方案，对优秀的联合创新场景提供市场推广支持"
      },
      {
        "title": "伙伴认证服务",
        "text": "由华为云给联创伙伴提供华为云最佳创新应用伙伴认证证书"
      }
    ]
  },
  "join": {
    "title": {
      "mainTitle": "加入联创营",
      "subTitle": "和“5G+X”联创营一起携手共进，探索新应用，共建新生态"
    },
    "content": {
      "title": "“5G+X”联创营欢迎所有优秀合作伙伴的加入，如果你：",
      "list": [
        "是一家具有前瞻产品 技术能力开发强的企业",
        "是一家致力于企业智能和体验服务的初创企业或独角兽",
        "拥有自主知识产权的解决方案或产品",
        "拥有打造企业服务场景的能力",
        "拥有一定规模的客户和市场能力",
        "对 “5G+X”联创营有兴趣，愿意与华为云就创新和市场推广进行交流"
      ]
    },
    "button": {
      "link": "https://jinshuju.net/f/iYFPi5?x_field_1=shequn+",
      "text": "加入联创营"
    }
  },
  "footer": {
    "title": "关于华为云",
    "text": "在提供安全、开放、智能的变革性企业级云平台方面，华为云是公认的全球领导者。我们的技术依托华为云专用网络构建而成，是近 20 年来在安全、网络架构、协作、人工智能和开源软件方面不懈创新的产物。我们在华为和华为云提供了一套设计简洁的工具和无可比拟的技术，帮助客户有效地融合人力、洞见和创意。来自 150 多个国家/地区的客户依靠华为云来实现计算环境现代化，以满足当今数字世界的需求。"
  }
}
